import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import Alert from '../components/Alert';
import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Select from '../components/Select';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import SubTitle from '../components/SubTitle';
import InfoText from '../components/InfoText';
import IconPDF from '../components/IconPDF';
import IconClose from '../components/IconClose';
import FormError from '../components/FormError';
import InfoTooltip from '../components/InfoTooltip';
import Spinner from '../components/Spinner';
import { click_submit_files } from '../techspec';

import { relacionLaboral } from '../data/relacionesLaborales';

import { breakpoints, subirArchivoPlatinum, confirmarSubidaPlatinum } from '../config';

import useStore from '../store';

import Dropzone from 'react-dropzone';
import prettyBytes from 'pretty-bytes';

const Files = props => {
  const [store, setStore] = useStore();

  const { register, errors, handleSubmit, watch, control, formState } = useForm({
    mode: 'onChange',
  });

  const { action, state } = useStateMachine(updateAction);

  const [files, setFiles] = useState({
    dependiente: [],
    comerciante: { ingresos: [], bps: [], dgi: [] },
    independiente: { ingresos: [], cajaProfesionales: [] },
    jubilado: [],
  });
  const [encodedFiles, setEncodedFiles] = useState([]);

  const [selectRelacionLaboral, setSelectRelacionLaboral] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onSubmit = data => {
    action(data);
    setIsLoading(true);
    setHasError(false);

    click_submit_files();

    getArrayTipoRelacionLaboral().map(async (file, i) => {
      //se invoca una vez por archivo
      subirArchivoPlatinum(state.data.solicitudId, await getBase64(file), file.type, file.tipoDoc)
        .then(response => {
          if (response && response.status === 200 && !hasError) {
            if (response.statusText === 'OK') {
              //si es el ultimo archivo en subirse
              if (i + 1 === getArrayTipoRelacionLaboral().length) {
                confirmarSubidaPlatinum(state.data.solicitudId)
                  .then(response => {
                    if (response && response.status === 200) {
                      if (response.statusText === 'OK') {
                        props.history.push('/success');
                      } else {
                        setHasError(true);
                      }
                    } else {
                      setHasError(true);
                    }
                    setIsLoading(false);
                  })
                  .catch(error => {
                    setHasError(true);
                    setIsLoading(false);
                  });
              }
            } else {
              setHasError(true);
            }
          } else {
            setHasError(true);
          }
        })
        .catch(error => {
          setHasError(true);
          setIsLoading(false);
        });
    });
  };

  const getArrayTipoRelacionLaboral = () => {
    switch (selectRelacionLaboral) {
      case 'dependiente':
        return files.dependiente;
      case 'comerciante':
        return [...files.comerciante.ingresos, ...files.comerciante.bps, ...files.comerciante.dgi];
      case 'independiente':
        return [...files.independiente.ingresos, ...files.independiente.cajaProfesionales];
      case 'jubilado':
        return files.jubilado;
    }
  };

  const handleRemoveFile = (path, type) => {
    switch (type) {
      case 'dependiente':
        setFiles({
          ...files,
          dependiente: files.dependiente.filter(oneFile => oneFile.path !== path),
        });
        break;
      case 'comerciante/ingresos':
        setFiles({
          ...files,
          comerciante: {
            ...files.comerciante,
            ingresos: files.comerciante.ingresos.filter(oneFile => oneFile.path !== path),
          },
        });
        break;
      case 'bps':
        setFiles({
          ...files,
          comerciante: {
            ...files.comerciante,
            bps: files.comerciante.bps.filter(oneFile => oneFile.path !== path),
          },
        });
        break;
      case 'dgi':
        setFiles({
          ...files,
          comerciante: {
            ...files.comerciante,
            dgi: files.comerciante.dgi.filter(oneFile => oneFile.path !== path),
          },
        });
        break;
      case 'independiente/ingresos':
        setFiles({
          ...files,
          independiente: {
            ...files.independiente,
            ingresos: files.independiente.ingresos.filter(oneFile => oneFile.path !== path),
          },
        });
        break;
      case 'cajaProfesional':
        setFiles({
          ...files,
          independiente: {
            ...files.independiente,
            cajaProfesionales: files.independiente.cajaProfesionales.filter(
              oneFile => oneFile.path !== path,
            ),
          },
        });
        break;
      case 'jubilado':
        setFiles({
          ...files,
          jubilado: files.jubilado.filter(oneFile => oneFile.path !== path),
        });
        break;
    }
  };

  function getBase64(file) {
    var reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
      };
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  //cuando cambia la relacion laboral en el select, vacia el state de files
  useEffect(() => {
    setSelectRelacionLaboral(watch('relacionLaboral') || state?.data?.department || '');
    document.activeElement.blur();
    setFiles({
      dependiente: [],
      comerciante: { ingresos: [], bps: [], dgi: [] },
      independiente: { ingresos: [], cajaProfesionales: [] },
      jubilado: [],
    });
    setEncodedFiles([]);
  }, [watch('relacionLaboral')]);

  useEffect(() => {
    FilesLayout(relacionLaboral);
  }, [relacionLaboral]);

  const FilesLayout = relacionLaboral => {
    switch (relacionLaboral) {
      case 'dependiente':
        return <Dependiente />;
      case 'jubilado':
        return <Jubilado />;
      case 'independiente':
        return <Independiente />;
      case 'comerciante':
        return <Comerciante />;
    }
  };

  const addDocType = (relacionLaboral, acceptedFiles) => {
    switch (relacionLaboral) {
      case 'dependiente':
        acceptedFiles[0].tipoDoc = 2;
        break;
      case 'comerciante/ingresos':
        acceptedFiles[0].tipoDoc = 3;
        break;
      case 'bps':
        acceptedFiles[0].tipoDoc = 4;
        break;
      case 'dgi':
        acceptedFiles[0].tipoDoc = 5;
        break;
      case 'independiente/ingresos':
        acceptedFiles[0].tipoDoc = 3;
        break;
      case 'cajaProfesional':
        acceptedFiles[0].tipoDoc = 6;
        break;
      case 'jubilado':
        acceptedFiles[0].tipoDoc = 7;
        break;
    }
  };

  const saveFile = (relacionLaboral, acceptedFiles) => {
    switch (relacionLaboral) {
      case 'dependiente':
        setFiles({
          ...files,
          dependiente: [...files.dependiente, ...acceptedFiles],
        });
        console.log(files);
        break;
      case 'comerciante/ingresos':
        setFiles({
          ...files,
          comerciante: {
            ...files.comerciante,
            ingresos: [...files.comerciante.ingresos, ...acceptedFiles],
          },
        });
        break;
      case 'bps':
        setFiles({
          ...files,
          comerciante: { ...files.comerciante, bps: [...files.comerciante.bps, ...acceptedFiles] },
        });
        break;
      case 'dgi':
        setFiles({
          ...files,
          comerciante: {
            ...files.comerciante,
            dgi: [...files.comerciante.dgi, ...acceptedFiles],
          },
        });
        break;
      case 'independiente/ingresos':
        setFiles({
          ...files,
          independiente: {
            ...files.independiente,
            ingresos: [...files.independiente.ingresos, ...acceptedFiles],
          },
        });
        break;
      case 'cajaProfesional':
        setFiles({
          ...files,
          independiente: {
            ...files.independiente,
            cajaProfesionales: [...files.independiente.cajaProfesionales, ...acceptedFiles],
          },
        });
        break;
      case 'jubilado':
        setFiles({
          ...files,
          jubilado: [...files.jubilado, ...acceptedFiles],
        });
        break;
    }
  };

  const getArrayFileType = type => {
    switch (type) {
      case 'dependiente':
        return files.dependiente;
      case 'comerciante/ingresos':
        return files.comerciante.ingresos;
      case 'bps':
        return files.comerciante.bps;
      case 'dgi':
        return files.comerciante.dgi;
      case 'independiente/ingresos':
        return files.independiente.ingresos;
      case 'cajaProfesional':
        return files.independiente.cajaProfesionales;
      case 'jubilado':
        return files.jubilado;
    }
  };

  const DropzoneComponent = props => {
    return (
      <Dropzone
        accept={['image/jpg', 'image/jpeg', 'application/pdf']}
        maxSize={5242880}
        maxFiles={props.maxFiles}
        // multiple={props.maxFiles > 1 ? true : false}
        multiple={false}
        onDrop={acceptedFiles => {
          addDocType(props.type, acceptedFiles);
          saveFile(props.type, acceptedFiles);
          // acceptedFiles.map(async f => {
          //   setEncodedFiles([...encodedFiles, await getBase64(f)]);
          //   console.log(await getBase64(f));
          //   console.log(encodedFiles);
          // });
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />

            <div>
              <p>Seleccioná un PDF, una imagen JPG o arrastralo aquí</p>
              <div className="btnPDF">adjuntar</div>

              <style jsx>{`
                div {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  background-color: #f3f4f5;
                  border: 1px dashed #cccdcf;
                  border-radius: 4px;
                  padding: 16px;
                  margin: 5px 0;
                }

                p {
                  font-size: 14px;
                  line-height: 18px;
                  color: #868787;
                  margin: 0;
                  max-width: 230px;
                }

                .btnPDF {
                  color: #007ab7;
                  background-color: white;
                  border: 1px solid #007ab7;
                  border-radius: 4px;
                  padding: 10px 16px;
                  font-weight: 700;
                  min-width: 100px;
                  justify-content: center;
                }

                @media screen and (max-width: ${breakpoints.md}) {
                  .btnPDF {
                    font-size: 12px;
                    padding: 6px;
                  }
                }
              `}</style>
            </div>
          </div>
        )}
      </Dropzone>
    );
  };

  const UploadFileButton = props => {
    return (
      <>
        {getArrayFileType(props.type).length < props.maxFiles && (
          <div>
            <Controller
              as={<DropzoneComponent type={props.type} maxFiles={props.maxFiles} />}
              control={control}
              name="file"
              defaultValue={encodedFiles}
              rules={{
                validate: value => {
                  return getArrayFileType(props.type).length > 0 ? true : 'Debes subir un archivo';
                },
              }}
            />
            <InfoText>El tamaño máximo para subir un archivo es 5MB.</InfoText>
            {errors.file && <FormError>{errors.file.message}</FormError>}
          </div>
        )}

        <section>
          {getArrayFileType(props.type).length > 0 && (
            <ul>
              {getArrayFileType(props.type).map((file, index) => (
                <li key={index}>
                  <p>
                    <IconPDF />
                    {file.path}
                  </p>
                  <div>
                    <span>{prettyBytes(file.size)}</span>
                    <button onClick={() => handleRemoveFile(file.path, props.type)}>
                      <IconClose />
                    </button>
                  </div>
                </li>
              ))}
              <style jsx>{`
                    ul {
                      list-style: none;
                      border-radius: 4px;
                      padding: 0 16px;
                      background-color: white;
                      margin-bottom: 48px;
                    }

                    @media screen and (max-width: ${breakpoints.md}) {
                      ul {
                        max-width: 90vw;
                      }
                    }

                    li {
                      border-bottom: 1px solid #ebeff2;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    }

                    p {
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      width: 65%;
                      overflow: hidden;
                      margin: 1em 0;
                    }

                    @media screen and (max-width: ${breakpoints.md}) {
                      p {
                        width: 40%;
                      }
                    }

                    span {
                      color: #89837f;
                      font-size: 12px
                      line-height: 18px;
                      font-weight: 700;
                      border: 1px solid #D6D0CC;
                      border-radius: 4px;
                      padding: 4px 8px;
                    }

                    button {
                      border: none;
                      width: 25px;
                      height: 25px;
                      border-radius: 50%;
                      background-color: #FAF7F5;
                      cursor: pointer;
                      margin-left: 10px;
                    }

                    li:nth-last-child(1) {
                      border: none;
                    }
                  `}</style>
            </ul>
          )}
        </section>
      </>
    );
  };

  const Dependiente = () => {
    return (
      <>
        <SubTitle>Adjuntá tus recibos de sueldo</SubTitle>
        <InfoText>Si tu sueldo es variable, adjuntá los últimos 6 recibos.</InfoText>

        <UploadFileButton maxFiles={6} type={'dependiente'} />
      </>
    );
  };

  const Comerciante = () => {
    return (
      <>
        <SubTitle>Adjuntá tu certificado de ingresos</SubTitle>
        <UploadFileButton maxFiles={1} type={'comerciante/ingresos'} />

        <SubTitle>
          Adjuntá tu certificado de BPS{' '}
          <InfoTooltip text="El certificado de BPS debe estar al día" />
        </SubTitle>
        <UploadFileButton maxFiles={1} type={'bps'} />

        <SubTitle>
          Adjuntá tu certificado de DGI
          <InfoTooltip text="El certificado de DGI debe estar al día" />
        </SubTitle>
        <UploadFileButton maxFiles={1} type={'dgi'} />
      </>
    );
  };

  const Independiente = () => {
    return (
      <>
        <SubTitle>Adjuntá tu certificado de ingresos</SubTitle>
        <UploadFileButton maxFiles={1} type={'independiente/ingresos'} />

        <SubTitle>
          Adjuntá tu certificado de la Caja de Profesionales Universitarios
          <InfoTooltip text="El certificado de la Caja de Profesionales Universitarios debe estar al día" />
        </SubTitle>
        <UploadFileButton maxFiles={1} type={'cajaProfesional'} />
      </>
    );
  };

  const Jubilado = () => {
    return (
      <>
        <SubTitle>
          Adjuntá tu recibo de jubilación
          <InfoTooltip text="El recibo de jubilación debe estar al día" />
        </SubTitle>
        <UploadFileButton maxFiles={1} type={'jubilado'} />
      </>
    );
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Por último, necesitamos datos sobre tus ingresos</Title>

        <Select
          id="relacionLaboral"
          name="relacionLaboral"
          label="Relación laboral"
          placeholder="Selecciona tu relación laboral"
          options={relacionLaboral}
          register={register({ required: 'Debes seleccionar tu relacion laboral.' })}
          error={errors.relacionLaboral}
          defaultValue={state?.data?.relacionLaboral || ''}
        />

        {FilesLayout(selectRelacionLaboral)}
      </div>

      {hasError && <Alert />}

      <div className="form-actions">
        <Button block type="submit" disabled={isLoading} id="next-button-step-ingresos">
          {isLoading ? <Spinner size={10} /> : 'Enviar'}
        </Button>

        <BackButton />
      </div>
    </StackForm>
  );
};

export default withRouter(Files);
